import { Component, OnInit,Input } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TenderPlaceBidComponent } from '../tender-place-bid/tender-place-bid.component';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service'
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { TenderPricingOptionComponent } from '../tender-pricing-option/tender-pricing-option.component';
import moment from 'moment';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-pricing-option-confirm-bid',
    templateUrl: './tender-pricing-option-confirm-bid.component.html',
    styleUrls: ['./tender-pricing-option-confirm-bid.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class TenderPricingOptionConfirmBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  COI: boolean =false;
  OpenNegotiation:boolean=true;
  @Input() code:any;
  @Input() price:any;
  @Input() tabName: any;
  @Input() indexPrice:number;
  @Input() datePeriod:any;
  @Input() selectProduct:any;
  @Input() quantity:any
  @Input() quantityshw:any
  @Input() dischargePortshw:any
  @Input() isQuantityUnrestricted:boolean
  combinedchildlist:any = [];
  priceTab:any;
  productInfo:any;
  disabledBtn = false;
  product:any;
  tabValue: any;
  biddingTerms = '';
  requestParams: any;
  reqTenderEntries:any = [];
  @Input() finalQPFromDate:any;
  @Input() finalQPToDate:any;
  enableLoader: boolean = false;
  confirmTxt:string = null;

  constructor(private customProductService: CustomProductsService,private router:Router,public activeModal: NgbActiveModal,private Modal:NgbModal,
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    this.product=this.datePeriod;
    // this.productInfo=this.code;
    console.log(this.datePeriod,'product')

    if(this.datePeriod?.tenderEntries.length ==1){
    this.productInfo=this.code;
  }else{
    if(this.code.length==1){
      this.productInfo=this.code[0];
      console.log(this.productInfo,'productInfo')
    }else{
      this.productInfo=this.code;
      console.log(this.productInfo,'productInfo')
    }
  } 
    this.tabValue = this.tabName;
    if(this.datePeriod.groupTenders){
        this.datePeriod.combinedchildlist=[...this.productInfo.childList]
    }
    console.log(this.datePeriod,'tenders')
    if(this.datePeriod.groupTenders==undefined){
      console.log("in if", this.productInfo);
      
    this.requestParams = {
        "quoteAction": "BID_PLACED",
        "tender": {
          "buyerRemarks": this.biddingTerms,   
          "quoteCode": this.product.quoteCode,
          "tenderEntries": [
            {  "entryNumber": this.productInfo.entryNumber,
              "finalQPFromDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPFromDate:'',
              "finalQPToDate":this.productInfo.isQuotationPeriodUnrestricted==true || this.productInfo.isQPMultipleChoicesSelected == true?this.productInfo.finalQPToDate:'',
              "pricingOptionsEnum": [
                  {
                    "pricingOptions": this.productInfo.pricingOptionsEnum[0].pricingOptions,
                    "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp
                  }
                ],
              "productCode":  this.productInfo.productCode,
              "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
             [this.product.commodityType=='CN' ?"rcPrice":this.productInfo.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
              "currencyIso": "USD",
              "value":this.product.commodityType=='CN'? (this.productInfo.displayRCPriceConfig.displayRCPrice == true ? this.indexPrice : ""):this.price,
            },
            [this.product.commodityType=='CN'?"tcPrice":'tcPrice']: {
              "currencyIso":"USD",
              "value": this.product.commodityType=='CN'?this.price:'',
            },
            "quantity": this.productInfo?.isQuantityUnrestricted== true? this.productInfo.quantity: this.productInfo.quantity,
            }
          ]
        }

      }
      console.log(this.requestParams);
      
    }else{
      console.log("in else");
      
      this.datePeriod.combinedchildlist.map((val)=>{
        this.reqTenderEntries.push({ 
              "entryNumber": val.entryNumber,
              "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
            "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
                  "pricingOptionsEnum": [
                      {
                        "pricingOptions": this.productInfo.pricingOptionsEnum[0].pricingOptions,
                        "qpMultipleChoices": this.productInfo.combinedTenders[0].pricingOptionsEnum[0].qp
                      }
                    ],
                  "productCode":  val.productCode,
                  "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
                [this.datePeriod.commodityType=='CN'?"rcPrice":this.productInfo.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
                  "currencyIso": "USD",
                  "value":this.datePeriod.commodityType=='CN'? (this.productInfo.displayRCPriceConfig.displayRCPrice == true ? val.indexPrice : ""):val.price,
                },
                [this.datePeriod.commodityType=='CN'?"tcPrice":'tcPrice']: {
                  "currencyIso":"USD",
                  "value": this.datePeriod.commodityType=='CN'?val.price:'',
                },  "quantity": this.productInfo?.isQuantityUnrestricted== true? this.productInfo.quantity: this.productInfo.quantity,
          })
      }) 
    }
    console.log('finalQPFromDate-->',this.finalQPFromDate,' , finalQPToDate-->',this.finalQPToDate);

    console.log('from productInfofinalQPToDate-->',this.productInfo.finalQPToDate,' , finalQPTfinalQPFromDateoDate-->',this.productInfo.finalQPFromDate);

  } 
  convertingDateOnly(dateString,timezone): any {
    if (dateString) {
      return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
      }else{
        return '';
      }
  }
  submitBid(): any {
    if(this.datePeriod.groupTenders){
      this.requestParams={
        "quoteAction": "BID_PLACED",
      "tender": {
        "buyerRemarks": this.biddingTerms,   
        "quoteCode": this.product.quoteCode,
        "tenderEntries": this.reqTenderEntries
      }
    }
    }    
    this.requestParams.tender.buyerRemarks = this.biddingTerms;
    if(this.productInfo.dischargePortDetails && this.productInfo.isDischargePortUnrestricted== true){
      this.requestParams.tender.tenderEntries[0].dischargePortDetails=this.dischargePortshw
    }
    if(this.productInfo.quantity && this.productInfo.isQuantityUnrestricted== true){
      this.requestParams.tender.tenderEntries[0].quantity=this.quantityshw
    }
    if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
     this.requestParams.tender.tenderEntries[0].quantity=this.quantity
    }
    if(this.productInfo.isQuotationPeriodUnrestricted== true){
      this.requestParams.tender.tenderEntries[0].finalQPFromDate=this.finalQPFromDate
      this.requestParams.tender.tenderEntries[0].finalQPToDate=this.finalQPToDate
    }
    for (let data of this.reqTenderEntries) {
      if (this.product.commodityType != 'CN') {
        delete data.tcPrice
        delete data.rcPrice
      }
      if (this.product.commodityType == 'IO') {
        if (data.premiumDiscount){
          if (data.premiumDiscount?.value == '' || data.premiumDiscount?.value == undefined) {
            data.premiumDiscount.value = 0;
          }
        }
      }
    }
    if(this.product.commodityType=='CN' ){
        if(this.productInfo.displayRCPriceConfig.displayRCPrice == false){
        delete this.requestParams.tender.tenderEntries[0].rcPrice
      }
    }

   

    console.log(this.requestParams,'test');
    this.disabledBtn = true;
    this.enableLoader = true;
    this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
      console.log(resp);
      if(resp.status === 'BID_PLACED'){
      this.enableLoader = false;
        this.homeLinkClick(false);
        //this.toastrService.show(resp.status);
        this.activeModal.close();
        this.customProductService.bidPlaced = true;
        this.router.navigate([`/quotes/myquotes`]);
      }else{
        this.enableLoader = false;
        this.toastrService.show(resp.status?resp.status:'Sorry something went wrong,please try again later!');
      }
    },
    err=>{
      this.enableLoader = false;
      this.activeModal.close();
      this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
    })
    
  }
  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  backToPlacebid(): any{
    
    this.activeModal.close();
    const ModalRef = this.Modal.open(TenderPricingOptionComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.quantityshw = this.quantityshw;
    this.productInfo.finalQPFromDate=this.finalQPFromDate;
    this.productInfo.finalQPToDate=this.finalQPToDate;
    ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
    if(this.productInfo.pricingOptionsEnum[0]?.qp){
      ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
      if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
        ModalRef.componentInstance.displayFixedQPSection = true;
        ModalRef.componentInstance.finalQPFromDate=this.finalQPFromDate;
        ModalRef.componentInstance.finalQPToDate=this.finalQPToDate;
      }else{
        ModalRef.componentInstance.displayFixedQPSection = false;
      }
    }
    if (this.datePeriod?.tenderEntries.length ==1){
      ModalRef.componentInstance.productsInfo=this.datePeriod;
      if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity ){
      ModalRef.componentInstance.quantity=this.quantity;
          }
        }else{
            ModalRef.componentInstance.selectProduct=this.datePeriod;
            ModalRef.componentInstance.productsEntry=this.code;
            if(this.productInfo.minimumQuantity && this.productInfo.maximumQuantity){
            ModalRef.componentInstance.quantity=this.quantity;
            }
          }
    ModalRef.componentInstance.tabName = this.tabValue;
    if(this.product.commodityType=='CN'){
      ModalRef.componentInstance.price = this.price;
      ModalRef.componentInstance.indexPrice = this.indexPrice;
    }else{
      ModalRef.componentInstance.price = this.price;
    }
  
    // if(this.tabValue=='FIXED'){
    //   ModalRef.componentInstance.price = this.price;
    //   if(this.datePeriod?.tenderEntries.length ==1){
    //     this.code.pricingOptionsEnum[0].pricingOptions= this.tabValue;
    //   }else{
    //     this.code[0].pricingOptionsEnum[0].pricingOptions= this.tabValue;
    //   }
    // }
    // if(this.tabValue=='INDEX'){
    //    ModalRef.componentInstance.indexPrice = this.price;
    //    if(this.datePeriod?.tenderEntries.length ==1){
    //     this.code.pricingOptionsEnum[0].pricingOptions= this.tabValue;
    //   }else{
    //     this.code[0].pricingOptionsEnum[0].pricingOptions= this.tabValue;
    //   }
    // }
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }
  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }
  getLabelofConfirmScreen(priceOptions,commodityType,page){
    return this.customProductService.getLabelofConfirmScreen(priceOptions,commodityType,page);

  }
  getPriceandSymbol(priceOptions,price,commodityType){
  return this.customProductService.getPriceandSymbol(priceOptions,price,commodityType);
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
  }
}
